var n = 0;
function t() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "pr_id_";
  return n++, "".concat(t).concat(n);
}
export { t as default };